import React, { useState, useEffect } from "react"; 
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from "gatsby"
import loadable from "@loadable/component";

import { ApiRequest } from "../../common/utils/api_request_utils";
import { PageLinks } from "../../common/page-links";
import "./Careers.scss";

const Select = loadable(() => import("react-select"));

const CareersLanding = ({Module}) => {
    let brand_type = process.env.GATSBY_CAREER_BRAND || "dj-alexander";
    const[career_list, setCareerList] = useState([]);
    const[all_career_list, setAllCareerList] = useState([]);
    const[job_type, setJobType] = useState('');
    const[loading, setLoading] = useState(false);

    useEffect(() => {

        let career_api_url = `https://lomond-strapi.q.starberry.com/careers?_sort=expiry_date:DESC`;
        if(brand_type){
            career_api_url += `&brand=${brand_type}`
        }

        ApiRequest({
            method: "GET",
            url: career_api_url,
            header: {
                Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYzYmJjYzIxYjZhMzFjNjVmOGRiZTE4OCIsImlhdCI6MTY3NzE0MDE2NSwiZXhwIjoxOTkyNzE2MTY1fQ.EugjSp7GWcOVzSUJ-7N5bWEFXzS2hmq9xCPBRtUKuos`,
            }
        }, (result) => {
            if (result.length > 0) {
                setCareerList(result)
                setAllCareerList(result)
                setLoading(true)
            }
        })
        
    }, []);

    useEffect(() => {
        var career_arr =  all_career_list;
        if(job_type){
            career_arr = all_career_list.filter(item => item.employment_type === job_type)
        }
        setCareerList(career_arr)
    },[job_type])

    let options = [
        {label:"All Job Types", value: ""},
        {label:"Permanent", value: "Permanent"},
        {label:"Contract", value: "Contract"},
    ]

    //console.log("career_list ==>", career_list, all_career_list)

    return (
        <React.Fragment>
            <section className="careers_filter">
                <Container>
                    <div className="filter-boxes">
                        <strong className="filter-box">Job Type</strong>
                        <Select 
                            options={options}
                            placeholder="All Job Types" 
                            className="react-select"
                            classNamePrefix="react-select" 
                            onChange={(e) => setJobType(e.value)}
                            //menuIsOpen={true}                                        
                        />
                    </div>
                </Container>
            </section>

            <section className="careers_section">
                {loading && 
                <Container>
                    {career_list?.length > 0 ?
                        <div className="careers_list">
                            {career_list?.map((item, i) => {
                                return(
                                    <Link to={`/${PageLinks?.job_details}/${item.slug}/`}>
                                    <div className="careers_box">
                                        <span className="job_title">{item.title}</span>
                                        <span className="job_type"><i className="icon-breifcase" /> {item.employment_type}</span>
                                        <span className="job_location"><i className="icon-location" /> {item?.address?.county}</span>
                                        <span className="job_view">
                                            <Link to={`/${PageLinks?.job_details}/${item.slug}/`}>View Details 
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.66602 8H13.3327M13.3327 8L9.33268 4M13.3327 8L9.33268 12" stroke="#2ABED8" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </Link>
                                        </span>
                                    </div>
                                    </Link>
                                )
                            })}
                        </div>
                    :
                        <p className="text-center">No jobs found.</p>
                    }
                </Container>
                }
            </section>
        </React.Fragment>
    );
};
export default CareersLanding;
